"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Renderables_1 = require("../../Renderables");
var BaseInput_1 = require("../BaseInput");
/**
 * Implementation of the 'email' markup element.
 * An input HTML element is created of type email with
 * the given attributes name, placeholder and value. The
 * class lto-email is added to allow CSS manipulations.
 *
 * @see {@link IRenderable}
 */
var Email = /** @class */ (function (_super) {
    __extends(Email, _super);
    function Email(spec) {
        return _super.call(this, spec) || this;
    }
    /**
     * @inheritDoc
     */
    Email.prototype.render = function (renderer, isNested) {
        return this.initInput("email", "lto-email", isNested);
    };
    return Email;
}(BaseInput_1.BaseInput));
exports.Email = Email;
Renderables_1.default.register("email", Email);
